import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { QUERY_KEYS } from '@/utils/query-keys';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SafetyAndHygieneResponsibleService } from '@/infra/services/safety-hygiene-responsible';

interface CreateSafetyAndHygieneResponsibleParams {
	name: string;
	company_id: string;
	organization_id: string;
}

const Service = SafetyAndHygieneResponsibleService.getInstance();

export const useCreateSafetyAndHygieneResponsible = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (params: CreateSafetyAndHygieneResponsibleParams) => Service.create(params),
		onSuccess: () => {
			queryClient.invalidateQueries([QUERY_KEYS.GET_LIST_SAFETY_AND_HYGIENE_RESPONSIBLE]);
			message.success(I18n.get('Safety and hygiene responsible created successfully'));
		},
		onError: () => {
			message.error(I18n.get('Error on create safety and hygiene responsible'));
		}
	});
};
